var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellBing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5126 3.32959C11.7228 3.32959 7.61558 7.87427 7.61558 12.2266V15.032C7.61558 15.9404 7.24153 17.303 6.77397 18.0778L5.07739 20.9099C4.03539 22.6599 4.75677 24.6103 6.68045 25.2515C13.066 27.3756 19.9726 27.3756 26.3581 25.2515C28.1616 24.6504 28.9364 22.5397 27.9612 20.9099L26.2646 18.0778C25.797 17.303 25.423 15.927 25.423 15.032V14.2266",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9362 25.7991C20.9362 28.2438 18.9324 30.2476 16.4877 30.2476C15.2721 30.2476 14.1499 29.7399 13.3484 28.9384C12.5469 28.1369 12.0392 27.0147 12.0392 25.7991",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBing);
export default __webpack_public_path__ + "static/media/bell-bing.cf5a2e58.svg";
export { ForwardRef as ReactComponent };